module.exports = __webpack_public_path__ + "static/media/extend.eeb60f09.svg";